import Zajax from "./modules/zajax.js";
import Utils from "./modules/utils.js";
import Endpoint from "./modules/endpoint.js";
import RequestUtils from "./modules/request_utils.js";
import LivechatAttachments from "./modules/livechat_attachments.js";
import { createElement } from "./modules/components/dom_utils.js";

let script = document.createElement("script");
script.src = "https://unpkg.com/mqtt/dist/mqtt.min.js";
document.head.appendChild(script);

const fontLinks = [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: true },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Assistant:wght@200..800&display=swap",
  },
  {
    rel: "stylesheet",
    href: "https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&display=swap",
  },
];

fontLinks.forEach((linkProps) => {
  const link = document.createElement("link");
  Object.keys(linkProps).forEach((key) => {
    if (key === "crossorigin") {
      link.setAttribute("crossorigin", "");
    } else {
      link[key] = linkProps[key];
    }
  });
  document.head.appendChild(link);
});

const imageUrls = [
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/arrow_variant1.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/superagi_footer.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/typing.gif",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/audio_file.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/csv_file.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/default_file.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/doc_file.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/pdf_file.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/ppt_file.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/video_file.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/attach_file.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/download_file.svg",
  "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/more_vertical.svg",
];

imageUrls.forEach((url) => {
  const img = new Image();
  img.src = url;
});

let viewportMeta = document.createElement("meta");
viewportMeta.setAttribute("name", "viewport");
viewportMeta.setAttribute(
  "content",
  "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no",
);
document.head.appendChild(viewportMeta);

let workspaceId = Utils.getWorkspaceId();
let userId = Utils.getUserId();
let displayName = "Chat Support";
let external_user_id = null;
let user_email = RequestUtils.getUserEmail() || "";
let text_color = "#ffffff";
let theme_color = "#1890ff";
let widget_logo = "";
let isMobile = RequestUtils.isMobile();
let most_recent_message_time = new Date();
let past_message_count = 0;
let conversationClosedRendered = false;
let mqttClient = null;
let isConnected = false;
let subscriptions = new Map();
let messageHandlers = new Map();
let lastSoundPlayedMessageId = null;
let notificationAudio = null;
let typingTimeout = null;
let isTypingVisible = false;
let lastMessageType = null;
let currentVisibleTimestamp = null;
let refreshFailCount = 0;
let maxRefreshFailures = 5;
let baseRefreshInterval = 3000;
let currentRefreshInterval = 3000;

const styles = {
  widget: {
    mobile: `position: fixed !important; z-index: 2147483647 !important; display: none !important; width: 90vw !important; height: 85vh !important;
            border-radius: 15px !important; background-color: white !important; left: 5vw !important; bottom: 5vh !important;`,
    desktop: `position: fixed !important; z-index: 2147483647 !important; display: none !important; width: 24vw !important; min-width: 340px !important; max-width: 500px !important;
             border-radius: 16px !important; height: 74vh !important; min-height: 300px !important; background-color: white !important;`,
  },
  launcher: `position: fixed !important; z-index: 2147483647 !important; display: flex !important; justify-content: center !important; align-items: center !important; 
            cursor: pointer !important; border-radius: 50% !important; box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.30) !important;
            transition: transform 0.3s ease !important; padding: 6px !important; min-width: 50px !important; min-height: 50px !important; background-color: #FFF !important;`,
  messageWrapper: `width: 100% !important; margin-top: 6px !important;`,
  messageWrapperNewSet: `width: 100% !important; margin-top: 16px !important;`,
  message: `font-size: 14px !important; padding: 10px !important; border-radius: 8px !important; max-width: 75% !important; word-break: break-word !important;
           font-family: "Plus Jakarta", sans-serif !important; line-height: 1.4 !important;`,
  dateDiv: `margin: 28px 5px 5px 5px !important; text-align: center !important; font-size: 10px !important; color: rgba(0, 0, 0, 0.6) !important;
           font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;`,
  conversationClosedDiv: `margin: 28px 5px 5px 5px !important; text-align: center !important; font-size: 10px !important; color: rgba(0, 0, 0, 0.6) !important;
           font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;`,
  timer: `font-size: 11px !important; opacity: 0.65 !important; font-family: "Plus Jakarta", sans-serif !important;`,
  senderName: `font-size: 12px !important; font-weight: 600 !important; margin-bottom: 4px !important; padding-left: 4px !important; font-family: "Plus Jakarta", sans-serif !important; color: #111 !important;`,
};

const cssStyles = `
  #livechat_widget, #livechat_widget *, #livechat_widget *::before, #livechat_widget *::after,
  #livechat_widget_launcher, #livechat_widget_launcher *, #livechat_widget_launcher *::before, #livechat_widget_launcher *::after {
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    font-size: 100% !important;
    font: inherit !important;
    vertical-align: baseline !important;
    box-sizing: border-box !important;
    line-height: normal !important;
  }
  
  @keyframes scaleIn {
    from { transform: scale(0); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  }
  @keyframes scaleOut {
    from { transform: scale(1); opacity: 1; }
    to { transform: scale(0); opacity: 0; }
  }
  @keyframes rotateIn {
    from { transform: rotate(0deg); }
    to { transform: rotate(180deg); }
  }
  @keyframes rotateOut {
    from { transform: rotate(180deg); }
    to { transform: rotate(0deg); }
  }
  #livechat_widget.widget_scale_in { animation: scaleIn 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards !important; }
  #livechat_widget.widget_scale_out { animation: scaleOut 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards !important; }
  #livechat_widget_launcher .launcher_icon_open { animation: rotateIn 0.3s ease forwards !important; }
  #livechat_widget_launcher .launcher_icon_close { animation: rotateOut 0.3s ease forwards !important; }
  #livechat_widget .livechat_widget_messages {
    width: 100% !important; display: flex !important; flex-direction: column !important;
  }
  #livechat_widget .livechat_widget_messages div {
    white-space: pre-wrap !important; word-wrap: break-word !important;
  }
  #livechat_widget .livechat_widget_wrapper { border-radius: 16px !important; background: #FFF !important; box-shadow: -4px 4px 80px 0 rgba(0, 0, 0, 0.20) !important; height: 100% !important; display: flex !important; flex-direction: column !important; }
  #livechat_widget .livechat_widget_header { display: flex !important; justify-content: space-between !important; align-items: center !important; padding: 24px 14px !important; flex-shrink: 0 !important; }
  #livechat_widget .livechat_widget_center {
    overflow-y: auto !important; overflow-x: hidden !important; padding: 16px !important; display: flex !important; flex-direction: column-reverse !important; position: relative !important; flex: 1 !important;
  }
  #livechat_widget .livechat_widget_center::-webkit-scrollbar { width: 0 !important; display: none !important; }
  #livechat_widget .livechat_widget_footer {
    box-shadow: 0 -3px 8px rgba(0, 0, 0, 0.05) !important; padding: 8px 10px 0 15px !important; height: fit-content !important; min-height: 74px !important; background: white !important; flex-shrink: 0 !important;
  }
  #livechat_widget .widget_desktop_top { border-top-left-radius: 15px !important; border-top-right-radius: 15px !important; }
  #livechat_widget .widget_desktop_bottom { border-bottom-left-radius: 15px !important; border-bottom-right-radius: 15px !important; }
  #livechat_widget .widget_message_block {
    font-size: 14px !important; border: none !important; width: 90% !important; resize: none !important; font-family: "Plus Jakarta", sans-serif !important; padding: 4px 0 !important; 
    background-color: transparent !important; color: #4B5563 !important; min-height: 42px !important;
  }
  #livechat_widget .widget_message_block:hover, #livechat_widget .widget_message_block:focus, #livechat_widget .widget_message_block:active, #livechat_widget .widget_message_block:focus-visible {
    border: none !important; box-shadow: none !important; outline: none !important;
  }
  #livechat_widget .widget_message_block::placeholder {
    color: rgba(0, 0, 0, 0.20) !important;
  }
  #livechat_widget .livechat_widget_messages a.widget_message_link_incoming {
    color: #1890ff !important;
    text-decoration: none !important;
    transition: all 0.2s ease !important;
    font-weight: 500 !important;
  }
  #livechat_widget .livechat_widget_messages a.widget_message_link_incoming:hover {
    text-decoration: underline !important;
    opacity: 0.8 !important;
  }
  #livechat_widget .livechat_widget_messages a.widget_message_link_outgoing {
    color: ${text_color} !important;
    opacity: 0.8 !important;
    text-decoration: none !important;
    transition: all 0.2s ease !important;
    font-weight: 500 !important;
  }
  #livechat_widget .livechat_widget_messages a.widget_message_link_outgoing:hover {
    text-decoration: underline !important;
  }
`;

function getLocalStorageKey(key) {
  return `livechat_${key}_${workspaceId}`;
}

function getLocalStorageValue(key) {
  return localStorage.getItem(getLocalStorageKey(key));
}

function setLocalStorageValue(key, value) {
  localStorage.setItem(getLocalStorageKey(key), value);
}

function getWidgetEnvironment() {
  if (window.WIDGET_ENV) return window.WIDGET_ENV;
  const hostname = window.location.hostname;
  if (hostname === "localhost" || hostname === "127.0.0.1")
    return "development";
  if (hostname.includes("staging")) return "staging";
  return "production";
}

function formatTime(date) {
  return new Date(date).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

function formatDate(date) {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const isToday = date.toDateString() === today.toDateString();
  const isYesterday = date.toDateString() === yesterday.toDateString();

  const dateStr = date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  if (isToday) return `Today, ${dateStr}`;
  if (isYesterday) return `Yesterday, ${dateStr}`;
  return dateStr;
}

let LivechatWidget = {
  buildWidget(widget_settings) {
    if (
      !widget_settings ||
      Object.keys(widget_settings).length === 0 ||
      widget_settings.is_enabled === false
    ) {
      return;
    }

    const styleElement = createElement("style");
    styleElement.textContent = cssStyles;
    document.head.appendChild(styleElement);

    LivechatAttachments.init();

    const widget_position = widget_settings.widget_position || "right";
    const bottom_spacing = widget_settings.bottom_spacing || 10;
    const side_spacing = widget_settings.side_spacing || 10;
    text_color = widget_settings.text_color || "#ffffff";
    theme_color = widget_settings.theme_color || "#1890ff";
    displayName = widget_settings.display_name || "Chat Support";
    widget_logo = widget_settings.logo || "";

    const horizontal_position =
      widget_position === "left"
        ? `left: ${side_spacing}px !important;`
        : `right: ${side_spacing}px !important;`;
    const vertical_position = `bottom: ${bottom_spacing}px !important;`;
    const background_shadow =
      widget_position === "left"
        ? "box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.1) !important;"
        : "box-shadow: -10px 10px 30px rgba(0, 0, 0, 0.1) !important;";

    this.createLauncher(horizontal_position, vertical_position);
    this.createWidget(
      widget_position,
      horizontal_position,
      vertical_position,
      background_shadow,
      bottom_spacing,
    );
  },

  createLauncher(horizontal_position, vertical_position) {
    let launcher = document.getElementById("livechat_widget_launcher");
    if (launcher) return;

    const launcherContent = widget_logo
      ? `<img src="${widget_logo}" alt="Chat" style="width: 34px; height: 34px; object-fit: contain;" id="launcher_icon" />`
      : `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" id="launcher_icon">
          <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill="${theme_color}"/>
        </svg>`;

    launcher = createElement(
      "div",
      {
        id: "livechat_widget_launcher",
        style: `${styles.launcher} ${vertical_position} ${horizontal_position}`,
      },
      launcherContent,
    );

    launcher.addEventListener("mouseenter", () =>
      launcher.style.setProperty("transform", "scale(1.1)", "important"),
    );
    launcher.addEventListener("mouseleave", () =>
      launcher.style.setProperty("transform", "scale(1)", "important"),
    );
    launcher.addEventListener("click", () => {
      const chat = document.getElementById("livechat_widget");
      const icon = document.getElementById("launcher_icon");
      if (chat && chat.style.display === "block") {
        chat.classList.remove("widget_scale_in");
        chat.classList.add("widget_scale_out");
        if (icon) {
          icon.classList.remove("launcher_icon_open");
          icon.classList.add("launcher_icon_close");
        }
        setTimeout(() => {
          launcher.innerHTML = widget_logo
            ? `<img src="${widget_logo}" alt="Chat" style="width: 34px; height: 34px; object-fit: contain;" id="launcher_icon" class="launcher_icon_close" />`
            : `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" id="launcher_icon" class="launcher_icon_close">
              <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill="${theme_color}"/>
            </svg>`;
        }, 150);
        setTimeout(() => {
          chat.style.setProperty("display", "none", "important");
        }, 300);
      } else if (chat) {
        chat.style.setProperty("display", "block", "important");
        chat.classList.remove("widget_scale_out");
        chat.classList.add("widget_scale_in");
        if (icon) {
          icon.classList.remove("launcher_icon_close");
          icon.classList.add("launcher_icon_open");
        }
        setTimeout(() => {
          launcher.innerHTML = `<img src="https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/arrow_variant1.svg" alt="Close" style="width: 34px; height: 34px; rotate: 180deg;" id="launcher_icon" class="launcher_icon_open" />`;
        }, 150);
      }
    });

    document.body.appendChild(launcher);
  },

  createWidget(
    widget_position,
    horizontal_position,
    vertical_position,
    background_shadow,
    bottom_spacing,
  ) {
    let widget = document.getElementById("livechat_widget");
    if (widget) return;

    const widget_bottom = bottom_spacing + 64;
    const widget_vertical = `bottom: ${widget_bottom}px !important;`;

    const widgetStyle = isMobile
      ? `${styles.widget.mobile} ${background_shadow}`
      : `${styles.widget.desktop} transform-origin: bottom ${widget_position} !important; ${widget_vertical} ${horizontal_position} ${background_shadow}`;

    widget = createElement("div", {
      id: "livechat_widget",
      className: "widget_scale_in",
      style: widgetStyle,
    });

    widget.innerHTML = this.getWidgetHTML();
    document.body.appendChild(widget);

    setTimeout(() => {
      this.addEventListeners();
      LivechatMessages.getMessages();
      window.addEventListener("beforeunload", () =>
        LivechatMessages.disconnectMqtt(),
      );
    }, 1000);
  },

  getWidgetHTML() {
    const poweredByHTML = `
      <div style="display: flex !important; align-items: center !important; gap: 2px !important; justify-content: center !important; font-size: 10px !important; color: rgba(0, 0, 0, 0.6) !important; padding: 8px 0 !important; font-family: 'Inter', sans-serif !important;">
        Powered by
        <img src="https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/superagi_footer.svg" alt="SuperAGI" style="height: 12px !important; object-fit: contain !important;" />
      </div>`;

    return `
      <div class="livechat_widget_wrapper">
        <div class="livechat_widget_header ${isMobile ? "" : "widget_desktop_top"}" style="background-color: ${theme_color} !important;">
          <span class="font-medium text-base" style="color: ${text_color} !important; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important; font-size: 16px !important; font-weight: 500 !important;">${displayName}</span>
          <div style="color: ${text_color} !important; cursor: pointer !important;" id="widget_close_livechat">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="${text_color}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div id="livechat_widget_center" class="livechat_widget_center">
          <div class="livechat_widget_messages"></div>
        </div>
        <div class="livechat_widget_footer ${isMobile ? "" : "widget_desktop_bottom"}" id="livechat_widget_footer">
          <div id="widget_attachments_display" class="widget_attachments_container" style="display: none !important;"></div>
          <div style="display: flex !important; justify-content: space-between !important; gap: 8px !important; margin-bottom: 8px !important;">
            <input type="file" id="widget_file_input" style="display: none !important;" multiple accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.ppt,.pptx,.csv,.xls,.xlsx,.txt" />
            <div class="widget_attach_button" id="widget_attach_button">
              <img src="https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/attach_file.svg" alt="Attach" style="width: 20px !important; height: 20px !important;" />
            </div>
            <textarea id="widget_message_livechat" class="widget_message_block" placeholder="Type your message here.."></textarea>
            <div style="cursor: pointer !important; width: 30px !important; height: 30px !important; display: flex !important; align-items: center !important; justify-content: center !important;" id="widget_send_livechat">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" style="opacity: 0.9 !important;">
                <path d="M3 18.9993V5.99932C3 5.63266 3.15 5.35332 3.45 5.16132C3.75 4.96999 4.06667 4.94099 4.4 5.07432L19.8 11.5743C20.2167 11.7577 20.425 12.066 20.425 12.4993C20.425 12.9327 20.2167 13.241 19.8 13.4243L4.4 19.9243C4.06667 20.0577 3.75 20.0283 3.45 19.8363C3.15 19.645 3 19.366 3 18.9993ZM5 17.4993L16.85 12.4993L5 7.49932V10.9993L11 12.4993L5 13.9993V17.4993ZM5 12.4993V7.49932V17.4993V12.4993Z" fill="${theme_color}"/>
              </svg>
            </div>
          </div>
          ${poweredByHTML}
        </div>
      </div>`;
  },

  addEventListeners() {
    const textarea = document.getElementById("widget_message_livechat");
    const sendButton = document.getElementById("widget_send_livechat");
    const closeButton = document.getElementById("widget_close_livechat");
    const attachButton = document.getElementById("widget_attach_button");
    const fileInput = document.getElementById("widget_file_input");
    const widget = document.getElementById("livechat_widget");

    const sendMessage = () => {
      if (textarea) {
        const message = textarea.value.trim();
        const uploadedAttachments =
          LivechatAttachments.getUploadedAttachments();
        if (message !== "" || uploadedAttachments.length > 0) {
          LivechatMessages.sendMessage(message);
        }
      }
    };

    if (sendButton) sendButton.addEventListener("click", sendMessage);

    if (textarea) {
      textarea.addEventListener("keydown", (event) => {
        if (event.keyCode === 13 && !event.shiftKey) {
          event.preventDefault();
          sendMessage();
        }
      });
    }

    if (attachButton && fileInput) {
      attachButton.addEventListener("click", () => {
        fileInput.click();
      });

      fileInput.addEventListener("change", (event) => {
        const files = Array.from(event.target.files || []);
        if (files.length > 0) {
          LivechatAttachments.handleFileSelection(files, workspaceId);
          fileInput.value = "";
        }
      });
    }

    if (widget) {
      let dragCounter = 0;

      widget.addEventListener("dragenter", (event) => {
        event.preventDefault();
        event.stopPropagation();
        dragCounter++;
        if (dragCounter === 1) {
          widget.style.setProperty("border", "2px dashed " + theme_color, "important");
          widget.style.setProperty("background", "rgba(24, 144, 255, 0.02)", "important");
        }
      });

      widget.addEventListener("dragover", (event) => {
        event.preventDefault();
        event.stopPropagation();
      });

      widget.addEventListener("dragleave", (event) => {
        event.preventDefault();
        event.stopPropagation();
        dragCounter--;
        if (dragCounter === 0) {
          widget.style.removeProperty("border");
          widget.style.removeProperty("background");
        }
      });

      widget.addEventListener("drop", (event) => {
        event.preventDefault();
        event.stopPropagation();
        dragCounter = 0;
        widget.style.removeProperty("border");
        widget.style.removeProperty("background");
        
        const files = Array.from(event.dataTransfer.files || []);
        if (files.length > 0) {
          LivechatAttachments.handleFileSelection(files, workspaceId);
        }
      });
    }

    if (closeButton) {
      closeButton.addEventListener("click", () => {
        const launcher = document.getElementById("livechat_widget_launcher");
        const chat = document.getElementById("livechat_widget");
        if (chat) {
          chat.classList.remove("widget_scale_in");
          chat.classList.add("widget_scale_out");
          const icon = document.getElementById("launcher_icon");
          if (icon) {
            icon.classList.remove("launcher_icon_open");
            icon.classList.add("launcher_icon_close");
          }
          setTimeout(() => {
            const newIcon = widget_logo
              ? `<img src="${widget_logo}" alt="Chat" style="width: 34px; height: 34px; object-fit: contain;" id="launcher_icon" class="launcher_icon_close" />`
              : `<svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" id="launcher_icon" class="launcher_icon_close">
                <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" fill="${theme_color}"/>
              </svg>`;
            if (launcher) launcher.innerHTML = newIcon;
          }, 150);
          setTimeout(() => {
            chat.style.setProperty("display", "none", "important");
          }, 300);
        }
      });
    }
  },
};

let LivechatMessages = {
  convertUrlsToLinks(text, isIncoming) {
    const urlPattern =
      /(\b(?:https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])|(\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b)|(\b[A-Z0-9.-]+\.[A-Z]{2,}\b)/gi;
    return text.replace(urlPattern, (url) => {
      const href = url.match(/^https?:\/\//i) ? url : `https://${url}`;
      const class_name = isIncoming ? "widget_message_link_incoming" : "widget_message_link_outgoing";
      return `<a href="${href}" target="_blank" class="${class_name}" rel="noopener noreferrer">${url}</a>`;
    });
  },

  scrollToBottom() {
    const div = document.getElementById("livechat_widget_center");
    if (div) div.scrollTop = div.scrollHeight;
  },

  getMessages() {
    const centerSection = document.getElementById("livechat_widget_center");
    const footerSection = document.getElementById("livechat_widget_footer");

    if (footerSection)
      footerSection.style.setProperty("display", "block", "important");
    if (centerSection)
      centerSection.style.setProperty("display", "flex", "important");

    const userId = getLocalStorageValue("user_id");

    if (!userId) {
      this.renderPastMessages([], true);
      return;
    }

    const chatWidgetCenter = document.querySelector(
      ".livechat_widget_messages",
    );
    const hasExistingMessages =
      chatWidgetCenter &&
      chatWidgetCenter.querySelectorAll("[data-id]").length > 0;

    this.resetRefreshState();
    
    this.fetchMessages((messages, conversationStatus) => {
      this.renderPastMessages(messages || [], !hasExistingMessages, conversationStatus);
      this.initializeMqtt()
        .then(() => this.startPeriodicRefresh())
        .catch(() => this.startPeriodicRefresh());
    });
  },

  fetchMessages(callback) {
    Zajax.post(
      Endpoint.apiUrl() + "conversation/messages",
      {
        workspace_id: parseInt(workspaceId),
        external_id: external_user_id,
      },
      (response) => {
        if (response.success && response.messages) {
          callback(response.messages, response.conversation_status);
        }
      },
    );
  },

  initializeConversation() {
    const centerSection = document.getElementById("livechat_widget_center");
    const footerSection = document.getElementById("livechat_widget_footer");

    let entityId = getLocalStorageValue("entity_id");
    if (!entityId) {
      entityId = Date.now();
      setLocalStorageValue("entity_id", entityId);
    } else {
      entityId = parseInt(entityId);
    }

    this.createProfile(entityId, (success) => {
      if (success) {
        if (footerSection) footerSection.style.display = "block";
        if (centerSection) centerSection.style.display = "flex";
        this.renderPastMessages([], true);
        this.initializeMqtt()
          .then(() => this.startPeriodicRefresh())
          .catch(() => this.startPeriodicRefresh());
      }
    });
  },

  createProfile(entityId, callback) {
    Zajax.post(
      Endpoint.apiUrl() + "livechat/profile",
      {
        workspace_id: parseInt(workspaceId),
        entity_id: entityId,
        entity_type: "user",
        channel: "livechat",
        external_id: external_user_id,
        email: getLocalStorageValue("user_email") || "",
        name: getLocalStorageValue("user_name") || "",
      },
      (response) => {
        if (response.success) {
          if (response.data) {
            if (response.data.user_id)
              setLocalStorageValue("user_id", response.data.user_id);
            if (response.data.conversation_id)
              setLocalStorageValue(
                "conversation_id",
                response.data.conversation_id,
              );
          }
          setLocalStorageValue("entity_id", entityId);
          callback(true);
        } else {
          callback(false);
        }
      },
    );
  },

  sendMessage(message) {
    const textarea = document.getElementById("widget_message_livechat");
    if (!textarea) return;

    const uploadedAttachments = LivechatAttachments.getUploadedAttachments();
    const attachmentIds = uploadedAttachments.map((a) => a.id);

    textarea.value = "";
    const userId = getLocalStorageValue("user_id");

    if (!userId) {
      this.createConversationAndSendMessage(message);
      return;
    }

    const tempId = `temp_${Date.now()}_${btoa(unescape(encodeURIComponent(message.substring(0, 20))))}`;

    if (message || uploadedAttachments.length > 0) {
      this.renderCurrentMessage(
        message,
        false,
        {
          id: tempId,
          sent_time: new Date().toISOString(),
          attachments: uploadedAttachments,
        },
        true,
      );
    }

    if (!window.pendingMessages) window.pendingMessages = {};
    window.pendingMessages[message] = tempId;

    const payload = {
      workspace_id: parseInt(workspaceId),
      platform_user_id: parseInt(userId),
      message: message || "",
      channel: "livechat",
      external_id: external_user_id,
      email: getLocalStorageValue("user_email") || "",
      name: getLocalStorageValue("user_name") || "",
    };

    if (attachmentIds.length > 0) {
      payload.attachment_ids = attachmentIds;
    }

    Zajax.post(
      Endpoint.apiUrl() + "livechat/message",
      payload,
      (response) => {
        if (response.success) {
          LivechatAttachments.clearAttachments();
        } else {
          this.handleSendError(tempId, message, textarea);
        }
      },
      () => {
        this.handleSendError(tempId, message, textarea);
      },
    );
  },

  handleSendError(tempId, message, textarea) {
    const tempElement = document.querySelector(`[data-id='${tempId}']`);
    if (tempElement) tempElement.remove();
    textarea.value = message;
    delete window.pendingMessages[message];
  },

  createConversationAndSendMessage(message) {
    let entityId = getLocalStorageValue("entity_id");
    if (!entityId) {
      entityId = Date.now();
      setLocalStorageValue("entity_id", entityId);
    } else {
      entityId = parseInt(entityId);
    }

    conversationClosedRendered = false;

    this.createProfile(entityId, (success) => {
      if (success) {

        this.sendMessage(message);
        this.initializeMqtt()
          .then(() => this.startPeriodicRefresh())
          .catch(() => this.startPeriodicRefresh());
      }
    });
  },

  renderCurrentMessage(message, isIncoming, messageData, success) {
    const chatWidgetCenter = document.querySelector(
      ".livechat_widget_messages",
    );
    if (!chatWidgetCenter) return;

    if (
      messageData.id &&
      chatWidgetCenter.querySelectorAll(`[data-id='${messageData.id}']`)
        .length > 0
    ) {
      return;
    }

    const currentDate = new Date(messageData.sent_time || new Date());
    const currentTimeStr = formatTime(currentDate);

    const isSameDate =
      most_recent_message_time.toDateString() === currentDate.toDateString();
    if (!isSameDate || past_message_count <= 0) {
      const dateDiv = createElement(
        "div",
        { style: styles.dateDiv },
        formatDate(currentDate),
      );
      chatWidgetCenter.appendChild(dateDiv);
      most_recent_message_time = currentDate;
      past_message_count += 1;
    }

    const currentSender = isIncoming
      ? messageData.agent_name || displayName
      : "You";
    const currentType = isIncoming ? "agent" : "user";
    const showSenderName = lastMessageType !== currentType && isIncoming;
    const isNewSet =
      lastMessageType !== null && lastMessageType !== currentType;

    const messageDivWrapper = this.createMessageElement(
      message,
      isIncoming,
      messageData.id,
      currentTimeStr,
      showSenderName ? currentSender : null,
      isNewSet,
      messageData.attachments || [],
    );
    chatWidgetCenter.appendChild(messageDivWrapper);

    lastMessageType = currentType;

    this.scrollToBottom();
  },

  renderConversationClosedDivider() {
    if (conversationClosedRendered) return;

    const chatWidgetCenter = document.querySelector(
      ".livechat_widget_messages",
    );
    if (!chatWidgetCenter) return;

    conversationClosedRendered = true;

    const closedDiv = createElement(
      "div",
      { style: styles.conversationClosedDiv },
      "Conversation closed",
    );
    chatWidgetCenter.appendChild(closedDiv);
    this.scrollToBottom();
  },

  createMessageElement(
    message,
    isIncoming,
    id,
    timeStr,
    senderName,
    isNewSet,
    attachments = [],
  ) {
    const outerWrapper = createElement("div", {
      style: isNewSet ? styles.messageWrapperNewSet : styles.messageWrapper,
    });

    if (id) outerWrapper.setAttribute("data-id", id);

    if (senderName) {
      const senderDiv = createElement(
        "div",
        {
          style:
            styles.senderName +
            (isIncoming ? "" : "text-align: right; padding-right: 4px;"),
        },
        senderName,
      );
      outerWrapper.appendChild(senderDiv);
    }

    const messageDivWrapper = createElement("div", {
      style:
        "display: flex; flex-direction: column; width: 100%; gap: 6px;" +
        (isIncoming ? "align-items: flex-start;" : "align-items: flex-end;"),
    });

    if (message) {
      const messageDiv = createElement("div", {
        style:
          styles.message +
          (isIncoming
            ? "background-color: #f3f4f6; color: #111827; cursor: pointer;"
            : `background-color: ${theme_color}; color: ${text_color}; cursor: pointer;`),
      });

      const messageText = this.convertUrlsToLinks(
        message.replace(/\n/g, "<br>"),
        isIncoming,
      );
      const timerSpan = createElement(
        "span",
        {
          style: styles.timer + "display: none !important;",
          className: "message-timestamp",
        },
        timeStr,
      );

      messageDiv.innerHTML = messageText;
      messageDiv.appendChild(document.createElement("br"));
      messageDiv.appendChild(timerSpan);

      messageDiv.addEventListener("click", () => {
        if (currentVisibleTimestamp && currentVisibleTimestamp !== timerSpan) {
          currentVisibleTimestamp.style.setProperty(
            "display",
            "none",
            "important",
          );
        }
        if (timerSpan.style.display === "none") {
          timerSpan.style.setProperty("display", "inline", "important");
          currentVisibleTimestamp = timerSpan;
        } else {
          timerSpan.style.setProperty("display", "none", "important");
          currentVisibleTimestamp = null;
        }
      });

      messageDivWrapper.appendChild(messageDiv);
    }

    if (attachments && attachments.length > 0) {
      const attachmentsContainer =
        LivechatAttachments.createAttachmentsDisplay(attachments);
      messageDivWrapper.appendChild(attachmentsContainer);
    }

    outerWrapper.appendChild(messageDivWrapper);

    return outerWrapper;
  },

  renderPastMessages(messages, isInitialLoad = false, conversationStatus = null) {
    const chatWidgetCenter = document.querySelector(
      ".livechat_widget_messages",
    );
    if (!chatWidgetCenter) return;

    if (isInitialLoad) {
      chatWidgetCenter.innerHTML = "";
      lastMessageType = null;
    }

    this.replacePendingMessages(messages);

    const existingIds = new Set(
      Array.from(chatWidgetCenter.querySelectorAll("[data-id]")).map((el) =>
        el.getAttribute("data-id"),
      ),
    );

    let prevDate = null;
    past_message_count = messages.length;

    const sortedMessages = messages.sort(
      (a, b) =>
        new Date(a.sent_time || a.created_at) -
        new Date(b.sent_time || b.created_at),
    );

    for (const message of sortedMessages) {
      if (message.id && existingIds.has(message.id.toString())) continue;

      const currentDate = new Date(message.sent_time);
      most_recent_message_time = currentDate;

      const currentDateStr = formatDate(currentDate);

      if (prevDate !== currentDateStr) {
        const dateDiv = createElement(
          "div",
          { style: styles.dateDiv },
          currentDateStr,
        );
        chatWidgetCenter.appendChild(dateDiv);
        prevDate = currentDateStr;
        lastMessageType = null;
      }

      this.renderCurrentMessage(
        message.message,
        message.entity_type === "agent",
        message,
        true,
      );
    }

    if (conversationStatus === "Closed") {
      this.renderConversationClosedDivider();
    }

    this.scrollToBottom();
  },

  replacePendingMessages(messages) {
    if (!window.pendingMessages) return;

    messages.forEach((msg) => {
      const tempId = window.pendingMessages[msg.message];
      if (tempId) {
        const tempElement = document.querySelector(`[data-id='${tempId}']`);
        if (tempElement) tempElement.setAttribute("data-id", msg.id.toString());
        delete window.pendingMessages[msg.message];
      }
    });
  },

  async initializeMqtt() {
    try {
      const currentUserId = getLocalStorageValue("user_id") || userId;
      if (!currentUserId || !workspaceId) return;

      if (mqttClient && isConnected) return mqttClient;

      if (mqttClient) this.disconnectMqtt();

      const credentials = await this.fetchMqttCredentials();
      if (!credentials) throw new Error("Failed to fetch MQTT credentials");

      // CRITICAL FIX: Prime SSL/TLS session before MQTT connection
      const { primeSSLConnection } = await import('./livechat_mqttSSLPriming.js');
      await primeSSLConnection(credentials.url);

      const mqtt = window.mqtt;
      if (!mqtt) throw new Error("MQTT library not loaded");

      const clientId = this.generateClientId();
      const options = {
        clientId,
        username: credentials.username,
        password: credentials.password,
        reconnectPeriod: 5000,
        connectTimeout: 30000,
        keepalive: 60,
        clean: true,
        rejectUnauthorized: false,
        protocolVersion: 4,
        wsOptions: {
          rejectUnauthorized: false,
          headers: {
            "User-Agent": "LiveChat-Widget-MQTT-Client",
            Origin: window.location.origin,
          },
          protocol: "mqtt",
        },
      };

      mqttClient = mqtt.connect(credentials.url, options);
      this.setupClientEventHandlers();

      return new Promise((resolve) => {
        const timeout = setTimeout(() => {
          isConnected = false;
          resolve(null);
        }, 35000);

        mqttClient.on("connect", () => {
          clearTimeout(timeout);
          isConnected = true;
          this.resetRefreshState();

          const topicUserId =
            external_user_id || userId || getLocalStorageValue("user_id");
          const topic = `${getWidgetEnvironment()}/livechat/${workspaceId}/${topicUserId}`;

          this.subscribe(topic, this.handleMqttMessage.bind(this));
          resolve(mqttClient);
        });

        mqttClient.on("error", () => {
          clearTimeout(timeout);
          isConnected = false;
          resolve(null);
        });
      });
    } catch (error) {
      throw error;
    }
  },

  async fetchMqttCredentials() {
    return new Promise((resolve) => {
      const currentUserId = getLocalStorageValue("user_id") || userId;

      Zajax.post(
        Endpoint.apiUrl() + "mqtt/credentials",
        {
          workspace_id: parseInt(workspaceId),
          user_id: currentUserId,
          is_secure: window.location.protocol === "https:",
        },
        (response) => {
          if (response.success && response.data) {
            resolve({
              username: response.data.username,
              password: response.data.password,
              url: response.data.url,
              user_id: response.data.user_id,
            });
          } else {
            resolve(null);
          }
        },
        () => resolve(null),
      );
    });
  },

  generateClientId() {
    return "widget_" + Math.random().toString(16).substring(2, 8);
  },

  setupClientEventHandlers() {
    if (!mqttClient) return;

    mqttClient.on("connect", () => {
      isConnected = true;
    });

    mqttClient.on("disconnect", () => {
      isConnected = false;
    });

    mqttClient.on("error", () => {
      isConnected = false;
      if (mqttClient) {
        mqttClient.end(true);
        mqttClient = null;
      }
    });

    mqttClient.on("message", (topic, message) => {
      this.handleMessage(topic, message);
    });

    mqttClient.on("close", () => {
      isConnected = false;
      mqttClient = null;
    });

    mqttClient.on("offline", () => {
      isConnected = false;
    });
  },

  subscribe(topic, messageHandler = null) {
    return new Promise((resolve) => {
      if (!mqttClient || !isConnected) {
        resolve(null);
        return;
      }

      mqttClient.subscribe(topic, { qos: 0 }, (err) => {
        if (!err) {
          subscriptions.set(topic, true);
          if (messageHandler) {
            this.registerMessageHandler(topic, messageHandler);
          }
          resolve(topic);
        } else {
          resolve(null);
        }
      });
    });
  },

  registerMessageHandler(topic, handler) {
    if (!messageHandlers.has(topic)) messageHandlers.set(topic, []);
    messageHandlers.get(topic).push(handler);
  },

  handleMessage(topic, message) {
    try {
      const handlers = messageHandlers.get(topic) || [];
      if (handlers.length > 0) {
        const parsedMessage = this.parseMessage(message);
        handlers.forEach((handler) => {
          try {
            handler(parsedMessage, topic);
          } catch (error) {}
        });
      }
    } catch (error) {}
  },

  parseMessage(message) {
    try {
      return JSON.parse(message.toString());
    } catch {
      return message.toString();
    }
  },

  handleMqttMessage(messageData) {
    try {
      if (messageData.event_type === "conversation_closed") {
        this.renderConversationClosedDivider();
        return;
      }

      if (messageData.event_type === "typing") {
        this.handleTypingEvent(messageData.typing_status);
        return;
      }

      if (messageData.message && messageData.entity_type) {
        this.hideTypingIndicator();
      }

      if (
        messageData.id &&
        document.querySelector(`[data-id='${messageData.id}']`)
      ) {
        return;
      }

      if (messageData.entity_type === "agent") {
        this.renderCurrentMessage(messageData.message, true, messageData, true);

        if (lastSoundPlayedMessageId !== messageData.id) {
          lastSoundPlayedMessageId = messageData.id;
          this.playNotificationSound();
        }
      }
    } catch (error) {
      console.error("Error message:", error);
    }
  },

  disconnectMqtt() {
    if (mqttClient) {
      mqttClient.end(true);
      isConnected = false;
      subscriptions.clear();
      messageHandlers.clear();
      mqttClient = null;
    }
  },

  resetRefreshState() {
    refreshFailCount = 0;
    currentRefreshInterval = baseRefreshInterval;
  },

  startPeriodicRefresh() {
    if (this.refreshInterval) clearInterval(this.refreshInterval);

    const executeRefresh = () => {
      const widget = document.getElementById("livechat_widget");
      if (!widget || widget.style.display === "none") return;

      const userId = getLocalStorageValue("user_id");
      if (!userId || !workspaceId) return;

      if (refreshFailCount >= maxRefreshFailures) {
        if (this.refreshInterval) {
          clearInterval(this.refreshInterval);
          this.refreshInterval = null;
        }
        return;
      }

      this.fetchMessages(
        (messages, conversationStatus) => {
          this.replacePendingMessages(messages);

          const existingIds = new Set(
            Array.from(document.querySelectorAll("[data-id]")).map((el) =>
              el.getAttribute("data-id"),
            ),
          );

          const newMessages = messages.filter(
            (msg) => msg.id && !existingIds.has(msg.id.toString()),
          );

          newMessages.forEach((message) => {
            this.renderCurrentMessage(
              message.message,
              message.entity_type === "agent",
              message,
              true,
            );

            if (
              message.entity_type === "agent" &&
              lastSoundPlayedMessageId !== message.id
            ) {
              lastSoundPlayedMessageId = message.id;
              this.playNotificationSound();
            }
          });

          if (conversationStatus === "Closed" && !conversationClosedRendered) {
            this.renderConversationClosedDivider();
          }
        },
        () => {
          refreshFailCount++;

          currentRefreshInterval = Math.min(
            baseRefreshInterval * Math.pow(2, refreshFailCount - 1),
            30000
          );
          
          if (this.refreshInterval) clearInterval(this.refreshInterval);
          
          if (refreshFailCount < maxRefreshFailures) {
            this.refreshInterval = setInterval(executeRefresh, currentRefreshInterval);
          } else {
            console.error(`[LiveChat] Max failures reached. Refresh stopped.`);
            this.refreshInterval = null;
          }
        }
      );
    };
    this.refreshInterval = setInterval(executeRefresh, currentRefreshInterval);
  },

  playNotificationSound() {
    try {
      if (!notificationAudio) {
        notificationAudio = new Audio(
          "https://s3.amazonaws.com/contlo.in/new_message_left_panel.mp3",
        );
        notificationAudio.volume = 0.7;
        notificationAudio.preload = "auto";
      }
      notificationAudio.currentTime = 0;
      notificationAudio.play().catch(() => {});
    } catch {}
  },

  showTypingIndicator() {
    if (isTypingVisible) {
      return;
    }

    isTypingVisible = true;
    const chatWidgetCenter = document.querySelector(
      ".livechat_widget_messages",
    );
    if (!chatWidgetCenter) {
      return;
    }

    const isNewSet = lastMessageType !== null && lastMessageType !== "agent";

    const outerWrapper = createElement("div", {
      style: isNewSet ? styles.messageWrapperNewSet : styles.messageWrapper,
    });
    outerWrapper.setAttribute("data-id", "typing-indicator");

    const messageDivWrapper = createElement("div", {
      style: "display: flex; width: 100%; justify-content: flex-start;",
    });

    const messageDiv = createElement("div", {
      style:
        styles.message +
        "background-color: #f3f4f6; color: #111827; display: flex; align-items: center; gap: 8px; min-height: 40px;",
    });

    const typingImg = createElement("img", {
      src: "https://super-sales-public-files20240730144930944300000001.s3.us-east-1.amazonaws.com/inbound_agents/typing.gif",
      alt: "typing",
      style: "width: 24px; height: 24px;",
    });

    messageDiv.appendChild(typingImg);
    messageDivWrapper.appendChild(messageDiv);
    outerWrapper.appendChild(messageDivWrapper);
    chatWidgetCenter.appendChild(outerWrapper);

    this.scrollToBottom();
  },

  hideTypingIndicator() {
    if (!isTypingVisible) {
      return;
    }

    isTypingVisible = false;
    const typingElement = document.querySelector(
      `[data-id='typing-indicator']`,
    );
    if (typingElement) {
      typingElement.remove();
    } else {
      console.warn("[LiveChat Typing] Typing indicator element not found in DOM");
    }
  },

  handleTypingEvent(eventType) {
    if (eventType === "start") {
      this.showTypingIndicator();
      if (typingTimeout) clearTimeout(typingTimeout);
      typingTimeout = setTimeout(() => {
        this.hideTypingIndicator();
      }, 10000);
    } else if (eventType === "stop") {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
        typingTimeout = null;
      }
      this.hideTypingIndicator();
    }
  },
};

let LivechatHandler = {
  init(workspace_id) {
    workspaceId = workspace_id || Utils.getWorkspaceId();

    if (!workspaceId) return;

    external_user_id = RequestUtils.getUserExternalId(workspaceId);

    Zajax.get(
      Endpoint.apiUrl() + `widget-settings/${workspaceId}`,
      (response) => {
        if (response.success && response.data) {
          LivechatWidget.buildWidget(response.data);
        } else {
          LivechatWidget.buildWidget({
            is_enabled: true,
            display_name: "Chat Support",
            theme_color: "#1890ff",
            text_color: "#ffffff",
            widget_position: "right",
            side_spacing: 10,
            bottom_spacing: 10,
          });
        }
      },
    );
  },
};

export default LivechatHandler;